import { includes, split, startsWith, tail, toNumber, trim } from "lodash";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router";

// declare routes that should not be redirected
export const routeBlacklist = [
  "auth",
  "login",
  "logout",
  "signup",
  "join",
  "invite",
  "reset-password",
  "components",
  "onboarding",
  "newPassword",
  "account",
  "profile",
  "personal",
  "survey",
  "surveys",
  "assessment-order",
  "styleguide",
  "invite",
  "share",
];

export const useOrganisationRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLocationRedirect = () => {
    const { pathname, search } = location;
    const isAuthenticated = !!Cookies.get("_s");
    let path = pathname;
    const recentOrgValue = localStorage.getItem("recentOrg");
    let currentOrg = toNumber(recentOrgValue);
    if (path === "/org") {
      // localStorage.removeItem("recentOrg");
      return;
    }

    if (includes(routeBlacklist, path.split("/")[1]) || !isAuthenticated) {
      // if (!isAuthenticated && currentOrg) {
      //   localStorage.removeItem("recentOrg");
      // }

      return;
    }

    const orgId = toNumber(split(path, "/")[2]);
    const startsWithOrg = startsWith(path, "/org/");
    // Check if path starts with /org and has correct id
    if (startsWithOrg && orgId) {
      // If the orgId from the URL is different from the currentOrg, update localStorage

      if (currentOrg !== orgId) {
        localStorage.setItem("recentOrg", orgId.toString());
        currentOrg = orgId;
      }
      return;
    }

    // Check if path starts with number
    // If it does, remove the number and redirect to the path
    if (split(path, "/")[1].match(/^\d/)) {
      path = `/${tail(split(trim(path, "/"), "/")).join("/")}`;
    }

    const query = search ? `${search}` : "";

    if (!currentOrg) {
      return navigate(`/org${query}`, { replace: true });
    }

    return navigate(`/org/${currentOrg}${path}${query}`, {
      replace: true,
    });
  };

  useEffect(() => {
    handleLocationRedirect();
  }, [location]);

  return {
    handleLocationRedirect,
  };
};
